<div class="workplace-row">
  <div
    [attr.id]="triggerId"
    class="fake-select"
    [class.disabled]="selectionDisabled"
  >
    <span class="value">
      {{ workplaceValue?.name || selectPlaceholder }}
    </span>
    <ion-icon name="chevron-down-outline"></ion-icon>
  </div>
</div>

<ion-popover
  [trigger]="selectionDisabled ? undefined : triggerId"
  triggerAction="click"
  side="bottom"
  alignment="end"
  [dismissOnSelect]="true"
>
  <ng-template>
    <ion-content>
      <ion-radio-group
        [(ngModel)]="workplaceKey"
        (ionChange)="onWorkplaceSelect($event)"
      >
        <ion-list>
          <ion-item
            *ngFor="let workplace of validWorkplaces"
            button
            detail="false"
            (click)="selectWorkplace(workplace)"
          >
            <ion-label>{{ workplace.name }}</ion-label>
            <ion-radio slot="end" [value]="workplace.key"></ion-radio>
          </ion-item>
        </ion-list>
      </ion-radio-group>
    </ion-content>
  </ng-template>
</ion-popover>
